<template>
  <lottery-wallet-card>
    <template #header>
      <img
        :src="`/assets/sf/image/${itemData.type}_token.png`"
        class="header__icon"
      />
      <strong class="header__title"
        >{{ `${itemData.type.toUpperCase()}` }}<br />Oropo Lottery</strong
      >
      <span class="header__tag">Ticket</span>
    </template>

    <template #body>
      <div class="next-draw">
        <p class="next-draw__label">
          <em class="next-draw__label-inner">Next Draw</em>
        </p>
        <div class="next-draw__content">
          <p
            class="next-draw__content__round"
            v-if="itemData.nextDrawRound > 0"
          >
            #{{ itemData.nextDrawRound }} | Draw
          </p>
          <p class="next-draw__content__round --text-gray" v-else>#- | Draw</p>
          <p
            class="next-draw__content__datetime"
            v-if="itemData.nextDrawDateTime > 0"
          >
            {{ formattedNextDrawDateTime }}
          </p>
          <p class="next-draw__content__datetime --text-gray" v-else>-</p>
        </div>
      </div>

      <div class="prize-pot">
        <p class="prize-pot__label">
          <em class="prize-pot__label-inner">Prize Pot</em>
        </p>
        <div class="prize-pot__content">
          <p
            class="prize-pot__content__prize-in-usd"
            v-if="itemData.prizeInUsd > 0"
          >
            ~$
            {{ toCurrency(itemData.prizeInUsd) }}
          </p>
          <p class="prize-pot__content__prize-in-usd --text-gray" v-else>
            ~$ {{ toCurrency(itemData.prizeInUsd) }}
          </p>
          <p
            class="prize-pot__content__prize-in-token-type"
            v-if="itemData.prizeInTokenType > 0"
          >
            {{ toFormattedToken(itemData.prizeInTokenType) }}
            {{ itemData.type.toUpperCase() }}
          </p>
          <p class="prize-pot__content__prize-in-token-type --text-gray" v-else>
            {{ toFormattedToken(itemData.prizeInTokenType) }}
            {{ itemData.type.toUpperCase() }}
          </p>
        </div>
      </div>

      <input-button :size="'large'" @click="goTo(itemData.type)"
        >Go {{ itemData.type.toUpperCase() }} Lottery</input-button
      >
    </template>
  </lottery-wallet-card>
</template>

<script>
import InputButton from "@/components/atoms/InputButton";
import LotteryWalletCard from "@/components/molecules/LotteryWalletCard";
import { fromUnixTime, format } from "date-fns";
import numFormat from "number-format.js";

export default {
  name: "LotteryCard",
  components: {
    InputButton,
    LotteryWalletCard,
  },
  props: {
    itemData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    formattedNextDrawDateTime() {
      return format(
        fromUnixTime(this.itemData.nextDrawDateTime),
        "MMMM dd, yyyy HH:mm"
      );
    },
  },
  methods: {
    toCurrency(num) {
      return numFormat("#,##0.00", num);
    },
    toFormattedToken(num) {
      return numFormat("#,##0.00000", num);
    },
    goTo(type) {
      this.$store.dispatch("lotteries/updatePool", this.itemData);

      this.$router.push({
        name: "lottery-detail",
        params: {
          type,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.header {
  &__title {
    font-size: 1.8rem;
    font-weight: 800;
    grid-column: 2;
    line-height: 1.2;
    align-self: center;
  }
  &__icon {
    width: 54px;
    height: 54px;
    align-self: center;
  }
  &__tag {
    font-size: 1.1rem;
    height: 32px;
    line-height: 28px;
    border: 2px solid;
    padding: 0 16px;
    border-radius: 16px;
    display: inline-block;
    font-weight: bold;
    grid-column: 3;
    align-self: center;
  }
}
.next-draw {
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 24px;
  &__label-inner {
    background: $gradation-vertical;
    color: transparent;
    background-clip: text;
    font-size: 20px;
  }
  &__content {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
}
.prize-pot {
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 24px;

  &__label-inner {
    background: $gradation-vertical;
    color: transparent;
    background-clip: text;
    font-size: 20px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    &__prize-in-usd {
      font-size: 3rem;
      @include media(pc) {
        font-size: 4rem;
      }
    }
  }
}
.--text-gray {
  color: $gray1;
}
</style>